import React from 'react';

import CSSModules from 'react-css-modules';

import styles from './styles.module.scss';

interface ToolbarProps {
  showMarkdownLists: boolean;
}

const ToolbarComponent = ({showMarkdownLists = true}: ToolbarProps) => (
  <div id='toolbar' styleName='container'>
    <button className='ql-bold'>
      <img src='/resources/img/textEditor/bold.svg' alt='bold text' />
    </button>
    <button className='ql-italic'>
      <img src='/resources/img/textEditor/italic.svg' alt='italic text' />
    </button>
    <button className='ql-underline'>
      <img src='/resources/img/textEditor/underline.svg' alt='underline text' />
    </button>

    {showMarkdownLists && (
      <>
        <button className='ql-list' value='bullet'>
          <img
            src='/resources/img/textEditor/bullet-list.svg'
            alt='bullet list'
          />
        </button>
        <button className='ql-list' value='ordered'>
          <img
            src='/resources/img/textEditor/number-list.svg'
            alt='numbered list'
          />
        </button>
      </>
    )}

    <button className='ql-clean'>
      <img
        src='/resources/img/textEditor/clear-format.svg'
        alt='remove formatting'
      />
    </button>
  </div>
);

export const Toolbar = CSSModules(ToolbarComponent, styles);
